<dx-data-grid
  #editMetricDataGrid
  (onCellPrepared)="onCellPreparedMetric($event); onCellPreparedSwapSaveIcon($event)"
  (onEditCanceled)="metricEditEnd($event)"
  (onEditingStart)="metricEditStart($event)"
  (onEditorPreparing)="onEditorPreparingMetric($event)"
  (onInitNewRow)="putDefaultMetricValues($event)"
  (onOptionChanged)="checkEditDeviceTypeValidation.emit()"
  (onSaved)="metricEditEnd($event)"
  (onToolbarPreparing)="editMetricAddRowButton($event)"
  *ngIf="!!groupMetric"
  [columnResizingMode]="'widget'"
  [allowColumnResizing]="true"
  [appRowStateHighlight]="rowStateTracker"
  [appRowStateScope]="groupMetric?.id"
  [dataSource]="this.groupMetric!.metrics!"
  [disabled]="groupIsBeingEdited"
  [selectedRowKeys]="selectedMetricRow"
  [showBorders]="true"
  [showRowLines]="false"
  [wordWrapEnabled]="true"
  height="100%"
  keyExpr="id"
  style="min-width: 100%;">

  <dxo-toolbar>
    <dxi-item location="before">
      <div style="display: flex; align-items: center;">
        <p style="font-size:22px; margin: 0 0 0 10px;">{{ 'REGISTRY.DEVICE_TYPE.TABLES.METRICS' | translate }}</p>
        <app-row-state-badge [trackers]="[rowStateTracker]" [scoped]="true" [scope]="groupMetric?.id"></app-row-state-badge>
      </div>
    </dxi-item>
    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
    </dxi-item>
    <dxi-item location="before" *ngIf="isEditMode">
      <div *dxTemplate>
        <dx-button
          [hint]="translate.instant('BUTTONS.HINTS.IMPORT')"
          icon="import"
          stylingMode="text"
          (click)="triggerFileSelection()">
        </dx-button>

        <input
          type="file"
          accept="application/vnd.ms-excel, text/csv"
          style="display: none"
          #fileInput
          (change)="onFileSelected($event)">
      </div>
    </dxi-item>
    <dxi-item location="before">
      <div *dxTemplate>
        <dx-button
          [hint]="translate.instant('BUTTONS.HINTS.EXPORT')"
          (onClick)="objectsToCSV(this.groupMetric!.metrics!)"
          icon="download"
          stylingMode="text">
        </dx-button>
      </div>
    </dxi-item>
    <dxi-item locateInMenu="never" location="before" name="addRowButton" showText="inMenu"></dxi-item>
  </dxo-toolbar>

  <dxo-paging
    [enabled]="false">
  </dxo-paging>

  <dxo-editing
    [allowAdding]="isEditMode"
    [allowDeleting]="isEditMode"
    [allowUpdating]="isEditMode"
    [newRowPosition]="'last'"
    [useIcons]="true"
    mode="row">
    <dxo-texts
      addRow="{{'BUTTONS.HINTS.ADD' | translate}}"
      cancelRowChanges="{{'BUTTONS.CANCEL' | translate}}"
      deleteRow="{{'BUTTONS.DELETE' | translate}}"
      editRow="{{'BUTTONS.UPDATE' | translate}}"
      saveRowChanges="{{'BUTTONS.CONFIRM' | translate}}">
    </dxo-texts>
  </dxo-editing>

  <dxo-scrolling
    mode="standard"
    showScrollbar="onScroll">
  </dxo-scrolling>

  <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
  </dxo-search-panel>
  <dxo-selection mode="single"></dxo-selection>
  <dxi-column [visible]="false" dataField="id"></dxi-column>
  <dxi-column [width]="'400'" [minWidth]="20" caption="{{'REGISTRY.DEVICE_TYPE.METRIC.NAME' | translate}}"
              dataField="name">
    <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                         [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                         type="stringLength"></dxi-validation-rule>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column caption="{{'REGISTRY.DEVICE_TYPE.METRIC.ADDRESS' | translate}}"
              dataField="transportConfiguration.address"
              dataType="number">
    <dxi-validation-rule type="required"></dxi-validation-rule>
    <dxi-validation-rule max="65535"
                         message="{{'ERROR.NUMBER_OVER_LIMIT' | translate: {min: '0', max:'65535'} }}"
                         min="0"
                         type="range"></dxi-validation-rule>
  </dxi-column>
  <dxi-column [setCellValue]="setCellValue"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.DATA_TYPE' | translate}}"
              dataField="transportConfiguration.dataType">
    <dxo-lookup
      [dataSource]="getFilteredDataTypeValues(groupMetric, gmService.modbusDataTypeValues)"
      displayExpr="label"
      valueExpr="value">
    </dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column [width]="'125'"
              [minWidth]="20"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.BIT_POSITION' | translate}}"
              dataField="transportConfiguration.bitPosition"
              dataType="number">
    <dxi-validation-rule [validationCallback]="validateBit"
                           message="{{ 'COMMON.IS_INVALID' | translate }}"
                         type="custom"></dxi-validation-rule>
    <dxi-validation-rule type="range" [min]="0"></dxi-validation-rule>
  </dxi-column>
  <dxi-column [width]="'175'"
              [minWidth]="20"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.BYTE_ORDER' | translate}}"
              dataField="transportConfiguration.byteOrder">
    <dxo-lookup
      [dataSource]="gmService.byteOrderValues"
      displayExpr="label"
      valueExpr="value">
    </dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column [width]="'100'"
              [minWidth]="20"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.DIVIDER' | translate}}"
              dataField="divider"
              dataType="number">
    <dxi-validation-rule [validationCallback]="validateDivider"
                         message="{{ 'COMMON.IS_REQUIRED' | translate }}"
                         type="custom"></dxi-validation-rule>
    <dxi-validation-rule [validationCallback]="dividerRange"
                         message="{{'REGISTRY.DEVICE_TYPE.VALIDATION.DIVIDER' | translate}}"
                         type="custom">
    </dxi-validation-rule>
  </dxi-column>
  <dxi-column [editorOptions]="{
                                acceptCustomValue: true,
                                showClearButton: true,
                                onCustomItemCreating: addNewDataUnit,
                                itemTemplate: 'dataUnitItemTemplate',
                                calculateDisplayValue: calculateMetricValue
                              }"
              [width]="'120'"
              [minWidth]="20"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.DATA_UNIT' | translate}}"
              dataField="dataUnit.id">
    <dxo-lookup
      [dataSource]="this.dataUnitValues"
      displayExpr="name"
      valueExpr="id">
    </dxo-lookup>
  </dxi-column>
  <dxi-column [editorOptions]="{ format: '#0', min: 0}" [width]="'100'"
              [minWidth]="20"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.DECIMAL_DIGITS' | translate}}"
              dataField="decimalDigits"
              dataType="number">
    <dxi-validation-rule [max]="gmService.DECIMAL_DIGITS_MAX" [min]="gmService.DECIMAL_DIGITS_MIN" type="range"></dxi-validation-rule>
  </dxi-column>

  <div *dxTemplate="let data of 'dataUnitItemTemplate'" class="custom-item">
    <div class="manufacturer-item">
      <span>{{ data.name }}</span>
      <dx-button (onClick)="deleteDataUnit(data, $event)" icon="trash" stylingMode="text"
                 type="default"></dx-button>
    </div>
  </div>

  <dxi-column *ngIf="isEditMode" type="buttons" [fixed]="true" fixedPosition="right">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
    <dxi-button icon="copy" [onClick]="onDuplicateMetricClick" hint="{{'REGISTRY.DEVICE_TYPE.BUTTONS.DUPLICATE' | translate}}"></dxi-button>
  </dxi-column>

</dx-data-grid>
